import React from "react";
import styled from "styled-components";
import { isMobileDevice } from "../../../utils/mobile";

const ExitSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.15006 6.0895C7.13842 6.07789 7.12919 6.06409 7.12289 6.04891C7.11658 6.03372 7.11334 6.01744 7.11334 6.001C7.11334 5.98456 7.11658 5.96828 7.12289 5.95309C7.12919 5.9379 7.13842 5.92411 7.15006 5.9125L11.7816 1.2815C11.9222 1.14067 12.0011 0.949742 12.001 0.750719C12.0008 0.551696 11.9216 0.36088 11.7808 0.220249C11.64 0.0796178 11.4491 0.000691141 11.25 0.000831792C11.051 0.000972442 10.8602 0.0801689 10.7196 0.220999L6.08856 4.85C6.07695 4.86164 6.06316 4.87088 6.04797 4.87718C6.03279 4.88348 6.01651 4.88672 6.00006 4.88672C5.98362 4.88672 5.96734 4.88348 5.95216 4.87718C5.93697 4.87088 5.92318 4.86164 5.91156 4.85L1.28056 0.220999C1.21093 0.151333 1.12826 0.0960638 1.03726 0.0583482C0.946271 0.0206325 0.84874 0.00120855 0.75024 0.00118533C0.551311 0.00113845 0.360511 0.0801178 0.219814 0.220749C0.0791162 0.36138 4.6905e-05 0.552143 2.08617e-08 0.751072C-4.68632e-05 0.950001 0.0789325 1.1408 0.219564 1.2815L4.85006 5.9125C4.8617 5.92411 4.87094 5.9379 4.87724 5.95309C4.88354 5.96828 4.88679 5.98456 4.88679 6.001C4.88679 6.01744 4.88354 6.03372 4.87724 6.04891C4.87094 6.06409 4.8617 6.07789 4.85006 6.0895L0.219564 10.721C0.14993 10.7907 0.0947003 10.8734 0.0570276 10.9644C0.0193548 11.0554 -2.31938e-05 11.1529 2.08617e-08 11.2514C4.6905e-05 11.4504 0.0791162 11.6411 0.219814 11.7817C0.28948 11.8514 0.372179 11.9066 0.46319 11.9443C0.554201 11.982 0.651741 12.0013 0.75024 12.0013C0.94917 12.0013 1.13993 11.9222 1.28056 11.7815L5.91156 7.15C5.92318 7.13836 5.93697 7.12912 5.95216 7.12282C5.96734 7.11652 5.98362 7.11328 6.00006 7.11328C6.01651 7.11328 6.03279 7.11652 6.04797 7.12282C6.06316 7.12912 6.07695 7.13836 6.08856 7.15L10.7196 11.7815C10.8602 11.9222 11.051 12.0013 11.2499 12.0013C11.4488 12.0014 11.6396 11.9224 11.7803 11.7817C11.921 11.6411 12.0001 11.4504 12.0001 11.2514C12.0002 11.0525 11.9212 10.8617 11.7806 10.721L7.15006 6.0895Z"
      fill="#949494"
    />
  </svg>
);

export const ExitIcon = styled(ExitSvg)`
  height: 12px;
  width: 12px;
  position: absolute;
  padding: 12px;
  right: 0;
  top: 0;
  cursor: pointer;
`;

export const ModalBG = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  cursor: pointer;
`;

interface ModalContainer {
  hasFooter?: boolean;
}

export const ModalContainer = styled.div<ModalContainer>`
  max-height: 80%;
  max-width: 440px;
  width: 100%;
  display: block;
  background: ${({ theme }) =>
    theme.darkMode ? theme.computedPrimary : "white"};
  border: 1px solid ${({ theme }) => (theme.darkMode ? "#5D5D5D" : "#dcdcdc")};
  box-shadow: 1px 4px 7px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: ${({ hasFooter }) => (hasFooter ? "24px 24px 12px" : "24px")};
  position: relative;
  ${() => isMobileDevice() && `margin: 0 12px;`};
  cursor: default;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.primaryText};
`;

export const Title = styled.span`
  font-family: Noto Sans;
  font-weight: bold;
  line-height: 16px;
  font-size: 16px;
  margin-bottom: 16px;
  color: ${({ theme }) => (theme.darkMode ? theme.primaryText : theme.primary)};
  display: block;
`;

export const Content = styled.div`
  font-size: 16px;
  line-height: 1.4;
  overflow-y: scroll;
  padding-bottom: 16px;
`;

export const Footer = styled.div`
  border-top: 1px solid
    ${({ theme }) => (theme.darkMode ? "#5D5D5D" : "#dcdcdc")};
  margin: 0 -24px -12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px;
`;
